"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _BuilderBlock = _interopRequireDefault(require("../../BuilderBlock"));
var _cccisdFormik = require("cccisd-formik");
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _xor2 = _interopRequireDefault(require("lodash/xor"));
var _defaultFilterFields = _interopRequireDefault(require("../../reportTemplatePlayer/FilterBar/defaultFilterFields.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Component = function Component(props) {
  var actualFields = props.filterFields.map(function (f) {
    return _objectSpread(_objectSpread({}, _defaultFilterFields["default"][f.name]), f);
  });
  return /*#__PURE__*/_react["default"].createElement(_BuilderBlock["default"], {
    title: "Filter bar"
  }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "hideFilterBar",
    component: _cccisdFormik.CccisdToggle,
    label: "Hide Filter Bar?"
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].filterBar
  }, /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "filterFields",
    render: function render(_ref) {
      var field = _ref.field,
        form = _ref.form;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        }
      }, "Filters"), actualFields.map(function (f) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: f.name,
          className: "form-check",
          style: {
            margin: 0
          }
        }, f.isRequired ? /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
          title: "Field is marked as required"
        }, /*#__PURE__*/_react["default"].createElement("input", {
          type: "checkbox",
          disabled: f.isRequired,
          name: "filterField.".concat(f.name),
          checked: field.value.includes(f.name),
          onChange: function onChange() {
            return form.setFieldValue('filterFields', (0, _xor2["default"])(field.value, [f.name]));
          },
          className: "form-check-input"
        }), /*#__PURE__*/_react["default"].createElement("label", {
          className: "form-check-label",
          htmlFor: "filterField.".concat(f.name)
        }, f.label)) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("input", {
          className: "form-check-input",
          type: "checkbox",
          disabled: f.isRequired,
          name: "filterField.".concat(f.name),
          checked: field.value.includes(f.name),
          onChange: function onChange() {
            return form.setFieldValue('filterFields', (0, _xor2["default"])(field.value, [f.name]));
          }
        }), /*#__PURE__*/_react["default"].createElement("label", {
          className: "form-check-label",
          htmlFor: "filterField.".concat(f.name)
        }, ' ', f.label)));
      }));
    }
  }), /*#__PURE__*/_react["default"].createElement(_cccisdFormik.Field, {
    name: "otherFilterOptions",
    render: function render(_ref2) {
      var field = _ref2.field,
        form = _ref2.form;
      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontWeight: 'bold'
        }
      }, "Move to Other Options"), actualFields.filter(function (f) {
        return form.values.filterFields.includes(f.name);
      }).map(function (f) {
        return /*#__PURE__*/_react["default"].createElement("div", {
          key: f.name,
          className: "form-check",
          style: {
            margin: 0
          }
        }, /*#__PURE__*/_react["default"].createElement("input", {
          className: "form-check-input",
          type: "checkbox",
          name: "filterField.".concat(f.name),
          checked: field.value.includes(f.name),
          onChange: function onChange() {
            return form.setFieldValue('otherFilterOptions', (0, _xor2["default"])(field.value, [f.name]));
          }
        }), /*#__PURE__*/_react["default"].createElement("label", {
          className: "form-check-label",
          htmlFor: "filterField.".concat(f.name)
        }, ' ', f.label));
      }));
    }
  })));
};
Component.propTypes = {
  filterFields: _propTypes["default"].array
};
var _default = exports["default"] = Component;